import React, {useState, useEffect, lazy, Suspense} from "react";
import {openSource} from "../../portfolio";
import Contact from "../contact/Contact";
import Loading from "../loading/Loading";

const renderLoader = () => <Loading />;
const GithubProfileCard = lazy(() =>
  import("../../components/githubProfileCard/GithubProfileCard")
);

export default function Profile() {
  const [prof, setProf] = useState(null);
  const showGithubProfile = openSource.showGithubProfile === "true";

  useEffect(() => {
    if (!showGithubProfile) {
      return;
    }

    fetch("/profile.json")
      .then(result => {
        if (result.ok) {
          return result.json();
        }
        throw new Error("Failed to fetch profile");
      })
      .then(response => {
        setProf(response.data.user);
      })
      .catch(function (error) {
        console.error(
          `${error} (because of this error GitHub contact section could not be displayed. Contact section has reverted to default)`
        );
        setProf("Error");
      });
  }, [showGithubProfile]);

  if (showGithubProfile && prof === null) {
    return renderLoader();
  }

  if (
    showGithubProfile &&
    prof !== "Error"
  ) {
    return (
      <Suspense fallback={renderLoader()}>
        <GithubProfileCard prof={prof} key={prof.id} />
      </Suspense>
    );
  }

  return <Contact />;
}
